/**
 * @generated SignedSource<<140988655be23af405c826461e3023dc>>
 * @relayHash d4766480174885064419f9ff8ab31bed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e88f840ffaf5621cb6f194a447d091a7620a2aaececfd071e5be5efdd3a1e3e1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isFCFAccessNarrowingEnabled_provider from '@atlassian/jira-relay-provider/src/fcf-its-with-access-narrowing.relayprovider';
import isNewTimeTrackingEditviewEnabled_provider from '@atlassian/jira-relay-provider/src/uim-its-time-tracking-original-estimate-support.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e88f840ffaf5621cb6f194a447d091a7620a2aaececfd071e5be5efdd3a1e3e1",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcfcfitswithaccessnarrowingrelayprovider": isFCFAccessNarrowingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcuimitstimetrackingoriginalestimatesupportrelayprovider": isNewTimeTrackingEditviewEnabled_provider
    }
  }
};

export default node;
